
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $6f019d1f45ba2738$export$2e2bcd8739ae039(targetElements, defaultProps) {
    if (!targetElements.length) return;
    ScrollReveal({
        reset: false
    });
    targetElements.forEach(({ element: element, animation: animation })=>{
        ScrollReveal().reveal(element, Object.assign({}, defaultProps, animation));
    });
}


var $b5f6d4efc654cf78$exports = {};
'use strict';
var $b5f6d4efc654cf78$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
/**
 * Created by Sergiu Șandor (micku7zu) on 1/27/2017.
 * Original idea: https://github.com/gijsroge/tilt.js
 * MIT License.
 * Version 1.8.0
 */ var $b5f6d4efc654cf78$var$VanillaTilt = function() {
    function VanillaTilt(element) {
        var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        $b5f6d4efc654cf78$var$classCallCheck(this, VanillaTilt);
        if (!(element instanceof Node)) throw "Can't initialize VanillaTilt because " + element + " is not a Node.";
        this.width = null;
        this.height = null;
        this.clientWidth = null;
        this.clientHeight = null;
        this.left = null;
        this.top = null;
        // for Gyroscope sampling
        this.gammazero = null;
        this.betazero = null;
        this.lastgammazero = null;
        this.lastbetazero = null;
        this.transitionTimeout = null;
        this.updateCall = null;
        this.event = null;
        this.updateBind = this.update.bind(this);
        this.resetBind = this.reset.bind(this);
        this.element = element;
        this.settings = this.extendSettings(settings);
        this.reverse = this.settings.reverse ? -1 : 1;
        this.resetToStart = VanillaTilt.isSettingTrue(this.settings["reset-to-start"]);
        this.glare = VanillaTilt.isSettingTrue(this.settings.glare);
        this.glarePrerender = VanillaTilt.isSettingTrue(this.settings["glare-prerender"]);
        this.fullPageListening = VanillaTilt.isSettingTrue(this.settings["full-page-listening"]);
        this.gyroscope = VanillaTilt.isSettingTrue(this.settings.gyroscope);
        this.gyroscopeSamples = this.settings.gyroscopeSamples;
        this.elementListener = this.getElementListener();
        if (this.glare) this.prepareGlare();
        if (this.fullPageListening) this.updateClientSize();
        this.addEventListeners();
        this.reset();
        if (this.resetToStart === false) {
            this.settings.startX = 0;
            this.settings.startY = 0;
        }
    }
    VanillaTilt.isSettingTrue = function isSettingTrue(setting) {
        return setting === "" || setting === true || setting === 1;
    };
    /**
   * Method returns element what will be listen mouse events
   * @return {Node}
   */ VanillaTilt.prototype.getElementListener = function getElementListener() {
        if (this.fullPageListening) return window.document;
        if (typeof this.settings["mouse-event-element"] === "string") {
            var mouseEventElement = document.querySelector(this.settings["mouse-event-element"]);
            if (mouseEventElement) return mouseEventElement;
        }
        if (this.settings["mouse-event-element"] instanceof Node) return this.settings["mouse-event-element"];
        return this.element;
    };
    /**
   * Method set listen methods for this.elementListener
   * @return {Node}
   */ VanillaTilt.prototype.addEventListeners = function addEventListeners() {
        this.onMouseEnterBind = this.onMouseEnter.bind(this);
        this.onMouseMoveBind = this.onMouseMove.bind(this);
        this.onMouseLeaveBind = this.onMouseLeave.bind(this);
        this.onWindowResizeBind = this.onWindowResize.bind(this);
        this.onDeviceOrientationBind = this.onDeviceOrientation.bind(this);
        this.elementListener.addEventListener("mouseenter", this.onMouseEnterBind);
        this.elementListener.addEventListener("mouseleave", this.onMouseLeaveBind);
        this.elementListener.addEventListener("mousemove", this.onMouseMoveBind);
        if (this.glare || this.fullPageListening) window.addEventListener("resize", this.onWindowResizeBind);
        if (this.gyroscope) window.addEventListener("deviceorientation", this.onDeviceOrientationBind);
    };
    /**
   * Method remove event listeners from current this.elementListener
   */ VanillaTilt.prototype.removeEventListeners = function removeEventListeners() {
        this.elementListener.removeEventListener("mouseenter", this.onMouseEnterBind);
        this.elementListener.removeEventListener("mouseleave", this.onMouseLeaveBind);
        this.elementListener.removeEventListener("mousemove", this.onMouseMoveBind);
        if (this.gyroscope) window.removeEventListener("deviceorientation", this.onDeviceOrientationBind);
        if (this.glare || this.fullPageListening) window.removeEventListener("resize", this.onWindowResizeBind);
    };
    VanillaTilt.prototype.destroy = function destroy() {
        clearTimeout(this.transitionTimeout);
        if (this.updateCall !== null) cancelAnimationFrame(this.updateCall);
        this.reset();
        this.removeEventListeners();
        this.element.vanillaTilt = null;
        delete this.element.vanillaTilt;
        this.element = null;
    };
    VanillaTilt.prototype.onDeviceOrientation = function onDeviceOrientation(event) {
        if (event.gamma === null || event.beta === null) return;
        this.updateElementPosition();
        if (this.gyroscopeSamples > 0) {
            this.lastgammazero = this.gammazero;
            this.lastbetazero = this.betazero;
            if (this.gammazero === null) {
                this.gammazero = event.gamma;
                this.betazero = event.beta;
            } else {
                this.gammazero = (event.gamma + this.lastgammazero) / 2;
                this.betazero = (event.beta + this.lastbetazero) / 2;
            }
            this.gyroscopeSamples -= 1;
        }
        var totalAngleX = this.settings.gyroscopeMaxAngleX - this.settings.gyroscopeMinAngleX;
        var totalAngleY = this.settings.gyroscopeMaxAngleY - this.settings.gyroscopeMinAngleY;
        var degreesPerPixelX = totalAngleX / this.width;
        var degreesPerPixelY = totalAngleY / this.height;
        var angleX = event.gamma - (this.settings.gyroscopeMinAngleX + this.gammazero);
        var angleY = event.beta - (this.settings.gyroscopeMinAngleY + this.betazero);
        var posX = angleX / degreesPerPixelX;
        var posY = angleY / degreesPerPixelY;
        if (this.updateCall !== null) cancelAnimationFrame(this.updateCall);
        this.event = {
            clientX: posX + this.left,
            clientY: posY + this.top
        };
        this.updateCall = requestAnimationFrame(this.updateBind);
    };
    VanillaTilt.prototype.onMouseEnter = function onMouseEnter() {
        this.updateElementPosition();
        this.element.style.willChange = "transform";
        this.setTransition();
    };
    VanillaTilt.prototype.onMouseMove = function onMouseMove(event) {
        if (this.updateCall !== null) cancelAnimationFrame(this.updateCall);
        this.event = event;
        this.updateCall = requestAnimationFrame(this.updateBind);
    };
    VanillaTilt.prototype.onMouseLeave = function onMouseLeave() {
        this.setTransition();
        if (this.settings.reset) requestAnimationFrame(this.resetBind);
    };
    VanillaTilt.prototype.reset = function reset() {
        this.onMouseEnter();
        if (this.fullPageListening) this.event = {
            clientX: (this.settings.startX + this.settings.max) / (2 * this.settings.max) * this.clientWidth,
            clientY: (this.settings.startY + this.settings.max) / (2 * this.settings.max) * this.clientHeight
        };
        else this.event = {
            clientX: this.left + (this.settings.startX + this.settings.max) / (2 * this.settings.max) * this.width,
            clientY: this.top + (this.settings.startY + this.settings.max) / (2 * this.settings.max) * this.height
        };
        var backupScale = this.settings.scale;
        this.settings.scale = 1;
        this.update();
        this.settings.scale = backupScale;
        this.resetGlare();
    };
    VanillaTilt.prototype.resetGlare = function resetGlare() {
        if (this.glare) {
            this.glareElement.style.transform = "rotate(180deg) translate(-50%, -50%)";
            this.glareElement.style.opacity = "0";
        }
    };
    VanillaTilt.prototype.getValues = function getValues() {
        var x = void 0, y = void 0;
        if (this.fullPageListening) {
            x = this.event.clientX / this.clientWidth;
            y = this.event.clientY / this.clientHeight;
        } else {
            x = (this.event.clientX - this.left) / this.width;
            y = (this.event.clientY - this.top) / this.height;
        }
        x = Math.min(Math.max(x, 0), 1);
        y = Math.min(Math.max(y, 0), 1);
        var tiltX = (this.reverse * (this.settings.max - x * this.settings.max * 2)).toFixed(2);
        var tiltY = (this.reverse * (y * this.settings.max * 2 - this.settings.max)).toFixed(2);
        var angle = Math.atan2(this.event.clientX - (this.left + this.width / 2), -(this.event.clientY - (this.top + this.height / 2))) * (180 / Math.PI);
        return {
            tiltX: tiltX,
            tiltY: tiltY,
            percentageX: x * 100,
            percentageY: y * 100,
            angle: angle
        };
    };
    VanillaTilt.prototype.updateElementPosition = function updateElementPosition() {
        var rect = this.element.getBoundingClientRect();
        this.width = this.element.offsetWidth;
        this.height = this.element.offsetHeight;
        this.left = rect.left;
        this.top = rect.top;
    };
    VanillaTilt.prototype.update = function update() {
        var values = this.getValues();
        this.element.style.transform = "perspective(" + this.settings.perspective + "px) " + "rotateX(" + (this.settings.axis === "x" ? 0 : values.tiltY) + "deg) " + "rotateY(" + (this.settings.axis === "y" ? 0 : values.tiltX) + "deg) " + "scale3d(" + this.settings.scale + ", " + this.settings.scale + ", " + this.settings.scale + ")";
        if (this.glare) {
            this.glareElement.style.transform = "rotate(" + values.angle + "deg) translate(-50%, -50%)";
            this.glareElement.style.opacity = "" + values.percentageY * this.settings["max-glare"] / 100;
        }
        this.element.dispatchEvent(new CustomEvent("tiltChange", {
            "detail": values
        }));
        this.updateCall = null;
    };
    /**
   * Appends the glare element (if glarePrerender equals false)
   * and sets the default style
   */ VanillaTilt.prototype.prepareGlare = function prepareGlare() {
        // If option pre-render is enabled we assume all html/css is present for an optimal glare effect.
        if (!this.glarePrerender) {
            // Create glare element
            var jsTiltGlare = document.createElement("div");
            jsTiltGlare.classList.add("js-tilt-glare");
            var jsTiltGlareInner = document.createElement("div");
            jsTiltGlareInner.classList.add("js-tilt-glare-inner");
            jsTiltGlare.appendChild(jsTiltGlareInner);
            this.element.appendChild(jsTiltGlare);
        }
        this.glareElementWrapper = this.element.querySelector(".js-tilt-glare");
        this.glareElement = this.element.querySelector(".js-tilt-glare-inner");
        if (this.glarePrerender) return;
        Object.assign(this.glareElementWrapper.style, {
            "position": "absolute",
            "top": "0",
            "left": "0",
            "width": "100%",
            "height": "100%",
            "overflow": "hidden",
            "pointer-events": "none",
            "border-radius": "inherit"
        });
        Object.assign(this.glareElement.style, {
            "position": "absolute",
            "top": "50%",
            "left": "50%",
            "pointer-events": "none",
            "background-image": "linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%)",
            "transform": "rotate(180deg) translate(-50%, -50%)",
            "transform-origin": "0% 0%",
            "opacity": "0"
        });
        this.updateGlareSize();
    };
    VanillaTilt.prototype.updateGlareSize = function updateGlareSize() {
        if (this.glare) {
            var glareSize = (this.element.offsetWidth > this.element.offsetHeight ? this.element.offsetWidth : this.element.offsetHeight) * 2;
            Object.assign(this.glareElement.style, {
                "width": glareSize + "px",
                "height": glareSize + "px"
            });
        }
    };
    VanillaTilt.prototype.updateClientSize = function updateClientSize() {
        this.clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        this.clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    };
    VanillaTilt.prototype.onWindowResize = function onWindowResize() {
        this.updateGlareSize();
        this.updateClientSize();
    };
    VanillaTilt.prototype.setTransition = function setTransition() {
        var _this = this;
        clearTimeout(this.transitionTimeout);
        this.element.style.transition = this.settings.speed + "ms " + this.settings.easing;
        if (this.glare) this.glareElement.style.transition = "opacity " + this.settings.speed + "ms " + this.settings.easing;
        this.transitionTimeout = setTimeout(function() {
            _this.element.style.transition = "";
            if (_this.glare) _this.glareElement.style.transition = "";
        }, this.settings.speed);
    };
    /**
   * Method return patched settings of instance
   * @param {boolean} settings.reverse - reverse the tilt direction
   * @param {number} settings.max - max tilt rotation (degrees)
   * @param {startX} settings.startX - the starting tilt on the X axis, in degrees. Default: 0
   * @param {startY} settings.startY - the starting tilt on the Y axis, in degrees. Default: 0
   * @param {number} settings.perspective - Transform perspective, the lower the more extreme the tilt gets
   * @param {string} settings.easing - Easing on enter/exit
   * @param {number} settings.scale - 2 = 200%, 1.5 = 150%, etc..
   * @param {number} settings.speed - Speed of the enter/exit transition
   * @param {boolean} settings.transition - Set a transition on enter/exit
   * @param {string|null} settings.axis - What axis should be enabled. Can be "x" or "y"
   * @param {boolean} settings.glare - if it should have a "glare" effect
   * @param {number} settings.max-glare - the maximum "glare" opacity (1 = 100%, 0.5 = 50%)
   * @param {boolean} settings.glare-prerender - false = VanillaTilt creates the glare elements for you, otherwise
   * @param {boolean} settings.full-page-listening - If true, parallax effect will listen to mouse move events on the whole document, not only the selected element
   * @param {string|object} settings.mouse-event-element - String selector or link to HTML-element what will be listen mouse events
   * @param {boolean} settings.reset - false = If the tilt effect has to be reset on exit
   * @param {boolean} settings.reset-to-start - true = On reset event (mouse leave) will return to initial start angle (if startX or startY is set)
   * @param {gyroscope} settings.gyroscope - Enable tilting by deviceorientation events
   * @param {gyroscopeSensitivity} settings.gyroscopeSensitivity - Between 0 and 1 - The angle at which max tilt position is reached. 1 = 90deg, 0.5 = 45deg, etc..
   * @param {gyroscopeSamples} settings.gyroscopeSamples - How many gyroscope moves to decide the starting position.
   */ VanillaTilt.prototype.extendSettings = function extendSettings(settings) {
        var defaultSettings = {
            reverse: false,
            max: 15,
            startX: 0,
            startY: 0,
            perspective: 1000,
            easing: "cubic-bezier(.03,.98,.52,.99)",
            scale: 1,
            speed: 300,
            transition: true,
            axis: null,
            glare: false,
            "max-glare": 1,
            "glare-prerender": false,
            "full-page-listening": false,
            "mouse-event-element": null,
            reset: true,
            "reset-to-start": true,
            gyroscope: true,
            gyroscopeMinAngleX: -45,
            gyroscopeMaxAngleX: 45,
            gyroscopeMinAngleY: -45,
            gyroscopeMaxAngleY: 45,
            gyroscopeSamples: 10
        };
        var newSettings = {};
        for(var property in defaultSettings){
            if (property in settings) newSettings[property] = settings[property];
            else if (this.element.hasAttribute("data-tilt-" + property)) {
                var attribute = this.element.getAttribute("data-tilt-" + property);
                try {
                    newSettings[property] = JSON.parse(attribute);
                } catch (e) {
                    newSettings[property] = attribute;
                }
            } else newSettings[property] = defaultSettings[property];
        }
        return newSettings;
    };
    VanillaTilt.init = function init(elements, settings) {
        if (elements instanceof Node) elements = [
            elements
        ];
        if (elements instanceof NodeList) elements = [].slice.call(elements);
        if (!(elements instanceof Array)) return;
        elements.forEach(function(element) {
            if (!("vanillaTilt" in element)) element.vanillaTilt = new VanillaTilt(element, settings);
        });
    };
    return VanillaTilt;
}();
if (typeof document !== "undefined") {
    /* expose the class to window */ window.VanillaTilt = $b5f6d4efc654cf78$var$VanillaTilt;
    /**
   * Auto load
   */ $b5f6d4efc654cf78$var$VanillaTilt.init(document.querySelectorAll("[data-tilt]"));
}
$b5f6d4efc654cf78$exports = $b5f6d4efc654cf78$var$VanillaTilt;


function $b8855ed206bb3c2e$export$2e2bcd8739ae039() {
    const elements = document.querySelectorAll(".js-tilt");
    (0, (/*@__PURE__*/$parcel$interopDefault($b5f6d4efc654cf78$exports))).init(elements);
}


const $d859da13df4a30ff$export$9c21a3269931e1e6 = {
    easing: "cubic-bezier(0.5, 0, 0, 1)",
    distance: "30px",
    duration: 1000,
    desktop: true,
    mobile: true
};
const $d859da13df4a30ff$export$adcf75ad64a03007 = [
    {
        element: ".section-title",
        animation: {
            delay: 300,
            distance: "0px",
            origin: "bottom"
        }
    },
    {
        element: ".hero-title",
        animation: {
            delay: 500,
            origin: window.innerWidth > 768 ? "left" : "bottom"
        }
    },
    {
        element: ".hero-cta",
        animation: {
            delay: 1000,
            origin: window.innerWidth > 768 ? "left" : "bottom"
        }
    },
    {
        element: ".about-wrapper__image",
        animation: {
            delay: 600,
            origin: "bottom"
        }
    },
    {
        element: ".about-wrapper__info",
        animation: {
            delay: 1000,
            origin: window.innerWidth > 768 ? "left" : "bottom"
        }
    },
    {
        element: ".project-wrapper__text",
        animation: {
            delay: 500,
            origin: window.innerWidth > 768 ? "left" : "bottom"
        }
    },
    {
        element: ".project-wrapper__image",
        animation: {
            delay: 1000,
            origin: window.innerWidth > 768 ? "right" : "bottom"
        }
    },
    {
        element: ".contact-wrapper",
        animation: {
            delay: 800,
            origin: "bottom"
        }
    }
];


(0, $6f019d1f45ba2738$export$2e2bcd8739ae039)((0, $d859da13df4a30ff$export$adcf75ad64a03007), (0, $d859da13df4a30ff$export$9c21a3269931e1e6));
(0, $b8855ed206bb3c2e$export$2e2bcd8739ae039)();
const $35da740d59af89ba$var$TRANSLATIONS = {
    "pt-BR": {
        "hero.greeting": "Ol\xe1, meu nome \xe9",
        "hero.role": "Eu sou Quality Assurance.",
        "hero.cta": "Saiba mais",
        "about.title": "Sobre mim",
        "about.p1": "Ol\xe1, meu nome \xe9 Eduardo. Graduado em Tecnologia em An\xe1lise e Desenvolvimento de Sistemas (TADS), com atua\xe7\xe3o em diversos projetos em contextos corporativos e acad\xeamicos",
        "about.p2": "Ao longo da minha jornada, explorei v\xe1rias \xe1reas da engenharia de software e descobri minha paix\xe3o por Garantia de Qualidade (QA), que se tornou minha principal habilidade. Com o tempo, foquei na implementa\xe7\xe3o de diferentes tipos de testes \u2014 automatizados, explorat\xf3rios, carga e regress\xe3o \u2014 contribuindo para o sucesso de projetos de diferentes complexidades.",
        "about.p3": "Minha abordagem \xe9 marcada por muita organiza\xe7\xe3o e por buscar c\xf3digo limpo e leg\xedvel, sempre priorizando clareza.",
        "about.p4": "Al\xe9m disso, sou m\xfasico e a bateria \xe9 meu instrumento \u2014 algo que reflete minha paix\xe3o por disciplina e ritmo, n\xe3o s\xf3 na m\xfasica, mas tamb\xe9m no desenvolvimento de software.",
        "about.resume": "Ver Curr\xedculo",
        "experience.title": "Experi\xeancia Profissional",
        "contact.title": "Contato",
        "contact.cta": "Fale comigo",
        "exp.sovis.title": "Analista de Qualidade de Software - Pleno",
        "exp.sovis.company": "Sovis",
        "exp.sovis.period": "ago de 2025 - o momento \xb7 6 meses | Brasil \xb7 Remota",
        "exp.joinqa.title": "Analista de Qualidade de Software - Pleno",
        "exp.joinqa.company": "Join Ads Network",
        "exp.joinqa.period": "out de 2024 - jun de 2025 \xb7 9 meses | Foz do Igua\xe7u, Paran\xe1, Brasil \xb7 Presencial",
        "exp.joinqa.desc": "Dediquei meus esfor\xe7os para implementar melhorias no processo de desenvolvimento. Como QA, apoiei a equipe de desenvolvimento ajudando na cobertura de testes unit\xe1rios e na automa\xe7\xe3o de testes E2E utilizando o Robot Framework. Auxiliei o time na configura\xe7\xe3o das pipelines de CI/CD, integrando os testes ao processo, de modo que a cada nova vers\xe3o os testes fossem executados para validar as implementa\xe7\xf5es. Implementei uma estrutura mais organizada para a esteira de desenvolvimento, incluindo pr\xe1ticas voltadas \xe0 garantia da qualidade do software entregue ao cliente. Criei testes E2E com o Robot Framework e testes unit\xe1rios utilizando o PestPHP. Durante esse per\xedodo, tamb\xe9m atuei na cria\xe7\xe3o de documenta\xe7\xf5es para apoiar os processos da equipe.",
        "exp.joinqa.skills": "Compet\xeancias: Testes automatizados de software \xb7 Qaops \xb7 Gest\xe3o de documentos \xb7 TesteCafe \xb7 Robot Framework \xb7 Aten\xe7\xe3o a detalhes \xb7 PHPUnit \xb7 PHP",
        "exp.joindev.title": "Desenvolvedor de Software - J\xfanior",
        "exp.joindev.company": "Join Ads Network",
        "exp.joindev.period": "set de 2024 - nov de 2024 \xb7 3 meses | Foz do Igua\xe7u, Paran\xe1, Brasil \xb7 Presencial",
        "exp.joindev.desc": "Atuando no desenvolvimento de features para diversos projetos internos, utilizando pr\xe1ticas de TDD para garantir a qualidade do c\xf3digo desde o in\xedcio. Colaborando com o time na implementa\xe7\xe3o de melhores pr\xe1ticas, promovendo a cultura de qualidade de software que desenvolvi ao longo dos anos. Contribuo com codereview, buscando aprimorar a consist\xeancia e efici\xeancia do desenvolvimento, al\xe9m de garantir a entrega de solu\xe7\xf5es de alta qualidade.",
        "exp.joindev.skills": "Compet\xeancias: Desenvolvimento de software \xb7 Gest\xe3o de documentos \xb7 Laravel \xb7 Sistemas operacionais \xb7 Aten\xe7\xe3o a detalhes \xb7 TDD \xb7 PHP",
        "exp.clinicorp.title": "Analista de Qualidade de Software - J\xfanior",
        "exp.clinicorp.company": "Clinicorp Solutions",
        "exp.clinicorp.period": "out de 2023 - set de 2024 \xb7 1 ano | Jaragu\xe1 do Sul, Santa Catarina, Brasil \xb7 H\xedbrida",
        "exp.clinicorp.desc": "Contribuindo para a Clinicorp, uma empresa que desenvolve um sistema abrangente de gerenciamento cl\xednico e est\xe9tico, otimizando as opera\xe7\xf5es di\xe1rias de cl\xednicas, desde o agendamento de pacientes at\xe9 a gest\xe3o financeira. A empresa conta com aproximadamente 300 colaboradores. Minhas atribui\xe7\xf5es iniciam nos times como QC (Controle de Qualidade), onde desempenho um papel fundamental nos est\xe1gios iniciais dos processos de desenvolvimento. Agrego valor ao produto e ao custo do projeto ao garantir a qualidade desde o in\xedcio. Al\xe9m disso, atuo como QA (Garantia de Qualidade), validando o processo de entrega das demandas das equipes. Trabalhando em v\xe1rias equipes, utilizo estrat\xe9gias como Kanban e Scrum para gerenciar eficientemente as atividades do dia a dia. Realizei automa\xe7\xe3o para testes E2E, tanto para front-end e back-end e mobile, utilizando Robot Framework. Este esfor\xe7o concluiu com o aumento da efici\xeancia e a qualidade nos processos de desenvolvimento.",
        "exp.clinicorp.skills": "Compet\xeancias: Execu\xe7\xe3o de testes \xb7 Kanban \xb7 Testes explorat\xf3rios \xb7 Scrum \xb7 Gest\xe3o de documentos \xb7 Xray \xb7 BDD \xb7 React.js \xb7 Garantia de qualidade \xb7 JIRA \xb7 Robot Framework \xb7 Comunica\xe7\xe3o \xb7 Cypress.io \xb7 Automa\xe7\xe3o de testes \xb7 Assist\xeancia ao produto \xb7 Gherkin \xb7 Node.js",
        "exp.live.title": "Desenvolvedor de Software - J\xfanior",
        "exp.live.company": "LIVE!",
        "exp.live.period": "ago de 2023 - out de 2023 \xb7 3 meses | Jaragu\xe1 do Sul, Santa Catarina, Brasil \xb7 Presencial",
        "exp.live.desc": "Trabalhei na Live!, uma empresa especializada em produtos t\xeaxteis voltados para moda fitness. Durante minha atua\xe7\xe3o presencial com uma equipe de desenvolvimento composta por 6 membros, utilizei metodologias \xe1geis como Scrum e Kanban para alinhar e organizar as demandas durante as sprints. Minhas responsabilidades eram centradas no desenvolvimento de funcionalidades cruciais para o sistema interno da f\xe1brica. O projeto envolvia o uso de React para o frontend e Java para o backend, incluindo a cria\xe7\xe3o de scripts SQL para consultas ao banco de dados. Ao colaborar com colegas de trabalho, obtive valiosos aprendizados, contribuindo tamb\xe9m com experi\xeancias anteriores em outras empresas. Destaco a aplica\xe7\xe3o de boas pr\xe1ticas de versionamento de c\xf3digo utilizando Git, enriquecendo ainda mais meu conhecimento e habilidades.",
        "exp.live.skills": "Compet\xeancias: Kanban \xb7 Oracle SQL Developer \xb7 Desenvolvimento de software \xb7 Scrum \xb7 React.js \xb7 Sistemas operacionais \xb7 Comunica\xe7\xe3o \xb7 Java",
        "exp.itaipu.title": "Desenvolvedor de Software - J\xfanior",
        "exp.itaipu.company": "Parque Tecnol\xf3gico Itaipu - Brasil",
        "exp.itaipu.period": "set de 2021 - nov de 2022 \xb7 1 ano 3 meses | Foz do Igua\xe7u, Paran\xe1, Brasil",
        "exp.itaipu.desc": "Trabalhei no Parque Tecnol\xf3gico de Itaipu, uma empresa com diversas \xe1reas de atua\xe7\xe3o, principalmente voltada para a inova\xe7\xe3o. Minha atua\xe7\xe3o foi no laborat\xf3rio GE.DT, com responsabilidades em projetos de energia. Entre minhas atividades, estavam a execu\xe7\xe3o de atividades t\xe9cnicas sob orienta\xe7\xe3o, assist\xeancia t\xe9cnica para desenvolvimento de projetos e pesquisas, manuten\xe7\xe3o de equipamentos e instala\xe7\xf5es, apoio na compra e utiliza\xe7\xe3o de m\xe1quinas, produtos e equipamentos, participa\xe7\xe3o em programas de pesquisa, fiscaliza\xe7\xe3o e inspe\xe7\xe3o das atividades, elabora\xe7\xe3o de projetos, realiza\xe7\xe3o de procedimentos necess\xe1rios para instala\xe7\xe3o e manuten\xe7\xe3o de m\xe1quinas e equipamentos, elabora\xe7\xe3o e atualiza\xe7\xe3o de instru\xe7\xf5es de procedimentos e normas, al\xe9m do atendimento ao p\xfablico interno e externo. Durante o meu tempo na empresa, tive a oportunidade de criar e atualizar a documenta\xe7\xe3o de um projeto que envolvia as esta\xe7\xf5es de produ\xe7\xe3o de energia. O objetivo desse projeto era monitorar e criar alertas dos disjuntores das esta\xe7\xf5es com base nos par\xe2metros inseridos no sistema. A arquitetura do sistema consistia em um projeto MVC, constru\xeddo em Java e PrimeFaces. Tamb\xe9m reportava aos engenheiros da Itaipu, em reuni\xf5es quinzenais, os progressos solicitados pela equipe de engenheiros da Itaipu, mantendo-os atualizados sobre o desenvolvimento do projeto.",
        "exp.itaipu.skills": "Compet\xeancias: Kanban \xb7 Primefaces \xb7 Metodologias Agile \xb7 Hyper-V \xb7 Desenvolvimento de software \xb7 Scrum \xb7 Java Architecture for XML Binding \xb7 Agendamento de reuni\xf5es \xb7 MySQL \xb7 Testes \xb7 Atas \xb7 Comunica\xe7\xe3o \xb7 Servidor Windows \xb7 Implementa\xe7\xe3o de software \xb7 Java",
        "exp.ibijus.title": "Analista de Qualidade de Software - J\xfanior",
        "exp.ibijus.company": "IbiJus - Instituto Brasileiro de Direito",
        "exp.ibijus.period": "mai de 2021 - set de 2021 \xb7 5 meses | Remota",
        "exp.ibijus.desc": "Trabalhei na Ibijus, uma empresa do ramo de direito que oferece cursos profissionalizantes e conta com uma equipe de 50-100 funcion\xe1rios. Minhas atribui\xe7\xf5es eram focadas na implementa\xe7\xe3o e manuten\xe7\xe3o dos testes na plataforma. Comecei criando e documentando testes explorat\xf3rios na plataforma, mapeando todos os cen\xe1rios de testes. Em seguida, implementei um processo de teste, corre\xe7\xe3o e re-teste, que consistia em gerenciar todo o processo da corre\xe7\xe3o desde o reporte de usu\xe1rios ou pela equipe de QA, passando pelo time de desenvolvimento para corre\xe7\xe3o e teste para validar a corre\xe7\xe3o. Tamb\xe9m ajudei a equipe na implementa\xe7\xe3o da integra\xe7\xe3o cont\xednua do sistema e participei de reuni\xf5es de dissemina\xe7\xe3o de conhecimento, realizadas a cada 15 dias, com o objetivo de trocar informa\xe7\xf5es, conquistas, c\xf3digos e curiosidades. Al\xe9m disso, participei de reuni\xf5es de alinhamento entre as equipes e utilizei metodologias \xe1geis como Scrum e Kanban. Minha atua\xe7\xe3o na empresa tamb\xe9m incluiu auxiliar o time com UX e, com excel\xeancia, pude contribuir com a empresa nos processos de Qualidade de Software, conquistando a cobertura das funcionalidades do sistema, desde os testes explorat\xf3rios at\xe9 os testes automatizados. Uma das minhas conquistas foi a implementa\xe7\xe3o do processo de mapear e gerenciar os reportes de bugs encontrados.",
        "exp.ibijus.skills": "Compet\xeancias: Git \xb7 Testes manuais \xb7 Kanban \xb7 Metodologias Agile \xb7 Integra\xe7\xe3o cont\xednua \xb7 Testes explorat\xf3rios \xb7 DBeaver \xb7 Scrum \xb7 Planejamento de testes \xb7 JavaScript \xb7 Garantia de qualidade \xb7 Aten\xe7\xe3o a detalhes \xb7 Comunica\xe7\xe3o \xb7 Cypress.io \xb7 Automa\xe7\xe3o de testes",
        "exp.intelltech.title": "Analista de Qualidade de Software",
        "exp.intelltech.company": "IntellTech Tecnologias Inteligentes",
        "exp.intelltech.period": "abr de 2019 - jan de 2021 \xb7 1 ano 10 meses | Foz do Igua\xe7u e Regi\xe3o, Brasil",
        "exp.intelltech.desc": "Trabalhei na IntellTech, uma empresa que oferece solu\xe7\xf5es para gerenciamento de barragens, um sistema modular com v\xe1rias funcionalidades e uma equipe de 50-100 funcion\xe1rios. Minha responsabilidade principal era implementar e manter os testes na plataforma. Atuando no time de QA, fui respons\xe1vel por criar e documentar cen\xe1rios de testes para mapear as funcionalidades do sistema, incluindo testes de carga e caixa-preta e caixa-branca. Al\xe9m disso, utilizei os aplicativos da Microsoft para gerenciar e documentar os bugs encontrados no sistema e criei testes automatizados usando o Selenium. Participei de reuni\xf5es entre equipes para disseminar conhecimento do sistema e planejamento de sprints. Tamb\xe9m auxiliei na corre\xe7\xe3o de bugs, garantindo a qualidade do sistema. Em resumo, minha contribui\xe7\xe3o na IntellTech ajudou a garantir uma cobertura completa de testes, desde testes explorat\xf3rios at\xe9 testes automatizados, e colaborou para o crescimento da empresa.",
        "exp.intelltech.skills": "Compet\xeancias: Testes manuais \xb7 Execu\xe7\xe3o de testes \xb7 Kanban \xb7 C# \xb7 Metodologias Agile \xb7 Testes de carga \xb7 Testes com Selenium \xb7 Selenium \xb7 Scrum \xb7 Documenta\xe7\xe3o de software \xb7 Planejamento de testes \xb7 Testes \xb7 Garantia de qualidade \xb7 Aten\xe7\xe3o a detalhes \xb7 Comunica\xe7\xe3o \xb7 Documenta\xe7\xe3o de usu\xe1rio \xb7 Automa\xe7\xe3o de testes \xb7 Testes funcionais \xb7 Microsoft 365"
    },
    en: {
        "hero.greeting": "Hi, my name is",
        "hero.role": "I'm a Quality Assurance professional.",
        "hero.cta": "Know more",
        "about.title": "About me",
        "about.p1": "Hello, my name is Eduardo. I have a degree in Systems Analysis and Development Technology (TADS), and have worked on various projects in both corporate and academic settings.",
        "about.p2": "Throughout my journey, I explored several areas of software engineering and discovered my passion for Quality Assurance (QA), which became my main focus. Over the years, I worked with different kinds of tests\u2014automated, exploratory, load, and regression\u2014contributing to projects of varying complexity.",
        "about.p3": "My approach is guided by strong organization and a focus on clean, readable code\u2014always aiming for clarity.",
        "about.p4": "Additionally, I'm a musician and drums are my instrument of choice\u2014reflecting my passion for discipline and rhythm, not only in music but also in software development.",
        "about.resume": "View Resume",
        "experience.title": "Professional Experience",
        "contact.title": "Contact",
        "contact.cta": "Contact me",
        "exp.sovis.title": "Software Quality Analyst (Mid-level)",
        "exp.sovis.company": "Sovis",
        "exp.sovis.period": "Aug 2025 - Present \xb7 6 months | Brazil \xb7 Remote",
        "exp.joinqa.title": "Software Quality Analyst (Mid-level)",
        "exp.joinqa.company": "Join Ads Network",
        "exp.joinqa.period": "Oct 2024 - Jun 2025 \xb7 9 months | Foz do Igua\xe7u, Paran\xe1, Brazil \xb7 On-site",
        "exp.joinqa.desc": "I focused on improving the development process. As a QA, I supported the development team by increasing unit test coverage and implementing E2E test automation using Robot Framework. I also helped set up CI/CD pipelines, integrating tests into the process so that tests ran on every new version to validate implementations. I implemented a more organized delivery pipeline with practices focused on software quality. I created E2E tests with Robot Framework and unit tests using PestPHP. During this period, I also produced documentation to support team processes.",
        "exp.joinqa.skills": "Skills: Test automation \xb7 QAOps \xb7 Document management \xb7 TestCafe \xb7 Robot Framework \xb7 Attention to detail \xb7 PHPUnit \xb7 PHP",
        "exp.joindev.title": "Junior Software Developer",
        "exp.joindev.company": "Join Ads Network",
        "exp.joindev.period": "Sep 2024 - Nov 2024 \xb7 3 months | Foz do Igua\xe7u, Paran\xe1, Brazil \xb7 On-site",
        "exp.joindev.desc": "I worked on features for internal projects, applying TDD practices to ensure code quality from the start. I collaborated with the team to implement best practices and promote a culture of software quality. I contributed to code reviews to improve consistency and development efficiency, ensuring high-quality deliveries.",
        "exp.joindev.skills": "Skills: Software development \xb7 Document management \xb7 Laravel \xb7 Operating systems \xb7 Attention to detail \xb7 TDD \xb7 PHP",
        "exp.clinicorp.title": "Junior Software Quality Analyst",
        "exp.clinicorp.company": "Clinicorp Solutions",
        "exp.clinicorp.period": "Oct 2023 - Sep 2024 \xb7 1 year | Jaragu\xe1 do Sul, Santa Catarina, Brazil \xb7 Hybrid",
        "exp.clinicorp.desc": "I contributed to Clinicorp, a company that develops a comprehensive clinical and aesthetic management system, optimizing daily clinic operations from scheduling to financial management (around 300 employees). I started in QC (Quality Control), playing a key role in early stages of the development process, ensuring quality from the beginning. I also worked as QA (Quality Assurance), validating delivery processes across teams. Working with multiple teams, I used strategies like Kanban and Scrum to manage day-to-day activities. I built E2E automation for front-end, back-end, and mobile using Robot Framework, improving efficiency and quality in the development process.",
        "exp.clinicorp.skills": "Skills: Test execution \xb7 Kanban \xb7 Exploratory testing \xb7 Scrum \xb7 Document management \xb7 Xray \xb7 BDD \xb7 React.js \xb7 Quality assurance \xb7 Jira \xb7 Robot Framework \xb7 Communication \xb7 Cypress \xb7 Test automation \xb7 Product support \xb7 Gherkin \xb7 Node.js",
        "exp.live.title": "Junior Software Developer",
        "exp.live.company": "LIVE!",
        "exp.live.period": "Aug 2023 - Oct 2023 \xb7 3 months | Jaragu\xe1 do Sul, Santa Catarina, Brazil \xb7 On-site",
        "exp.live.desc": "I worked at Live!, a company specialized in textile products for fitness fashion. On-site with a 6-person development team, I used agile methodologies such as Scrum and Kanban to align and organize sprint demands. My responsibilities focused on developing key features for the factory's internal system. The project used React for the frontend and Java for the backend, including creating SQL scripts for database queries. I also applied good version control practices with Git.",
        "exp.live.skills": "Skills: Kanban \xb7 Oracle SQL Developer \xb7 Software development \xb7 Scrum \xb7 React.js \xb7 Operating systems \xb7 Communication \xb7 Java",
        "exp.itaipu.title": "Junior Software Developer",
        "exp.itaipu.company": "Parque Tecnol\xf3gico Itaipu - Brazil",
        "exp.itaipu.period": "Sep 2021 - Nov 2022 \xb7 1 year 3 months | Foz do Igua\xe7u, Paran\xe1, Brazil",
        "exp.itaipu.desc": "I worked at Parque Tecnol\xf3gico Itaipu, an innovation-focused organization. I worked in the GE.DT lab on energy projects, performing technical activities under guidance, supporting research and project development, maintaining equipment and installations, assisting with purchases and usage of machines/equipment, participating in research programs, inspecting activities, drafting projects, and creating/updating procedures and standards. I also updated documentation for a project monitoring energy production stations, generating breaker alerts based on system parameters. The system architecture was MVC, built with Java and PrimeFaces. I reported progress to Itaipu engineers in biweekly meetings.",
        "exp.itaipu.skills": "Skills: Kanban \xb7 PrimeFaces \xb7 Agile methodologies \xb7 Hyper-V \xb7 Software development \xb7 Scrum \xb7 JAXB \xb7 Meeting scheduling \xb7 MySQL \xb7 Testing \xb7 Minutes \xb7 Communication \xb7 Windows Server \xb7 Software implementation \xb7 Java",
        "exp.ibijus.title": "Junior Software Quality Analyst",
        "exp.ibijus.company": "IbiJus - Brazilian Institute of Law",
        "exp.ibijus.period": "May 2021 - Sep 2021 \xb7 5 months | Remote",
        "exp.ibijus.desc": "I worked at IbiJus, a law-sector company offering professional courses (50\u2013100 employees). My responsibilities focused on implementing and maintaining tests on the platform. I started by creating and documenting exploratory tests and mapping test scenarios. Then I implemented a test-fix-retest flow, managing the full cycle from bug reports (users/QA) through development fixes and validation. I also helped implement continuous integration, participated in knowledge-sharing meetings every 15 days, and used agile methodologies such as Scrum and Kanban. I supported the team with UX and helped achieve broad test coverage\u2014from exploratory testing to automated tests\u2014including implementing a process to map and manage bug reports.",
        "exp.ibijus.skills": "Skills: Git \xb7 Manual testing \xb7 Kanban \xb7 Agile methodologies \xb7 Continuous integration \xb7 Exploratory testing \xb7 DBeaver \xb7 Scrum \xb7 Test planning \xb7 JavaScript \xb7 Quality assurance \xb7 Attention to detail \xb7 Communication \xb7 Cypress \xb7 Test automation",
        "exp.intelltech.title": "Software Quality Analyst",
        "exp.intelltech.company": "IntellTech Intelligent Technologies",
        "exp.intelltech.period": "Apr 2019 - Jan 2021 \xb7 1 year 10 months | Foz do Igua\xe7u Region, Brazil",
        "exp.intelltech.desc": "I worked at IntellTech, a company providing dam management solutions (a modular system with several features, 50\u2013100 employees). As part of the QA team, I created and documented test scenarios to map system functionality, including load testing and black-box/white-box testing. I used Microsoft tools to manage and document reported bugs and created automated tests using Selenium. I participated in cross-team meetings to share system knowledge and plan sprints, and I also supported bug fixes to ensure system quality.",
        "exp.intelltech.skills": "Skills: Manual testing \xb7 Test execution \xb7 Kanban \xb7 C# \xb7 Agile methodologies \xb7 Load testing \xb7 Selenium testing \xb7 Selenium \xb7 Scrum \xb7 Software documentation \xb7 Test planning \xb7 Testing \xb7 Quality assurance \xb7 Attention to detail \xb7 Communication \xb7 User documentation \xb7 Test automation \xb7 Functional testing \xb7 Microsoft 365"
    }
};
function $35da740d59af89ba$var$applyLanguage(lang) {
    const dict = $35da740d59af89ba$var$TRANSLATIONS[lang] || $35da740d59af89ba$var$TRANSLATIONS["pt-BR"];
    document.documentElement.lang = lang === "en" ? "en" : "pt-BR";
    document.querySelectorAll("[data-i18n]").forEach((el)=>{
        const key = el.getAttribute("data-i18n");
        const value = dict[key];
        if (typeof value === "string") el.textContent = value;
    });
    // Atualiza estado visual dos botões
    document.querySelectorAll(".lang-switch__btn").forEach((btn)=>{
        const isActive = btn.getAttribute("data-lang") === lang;
        btn.classList.toggle("lang-switch__btn--active", isActive);
    });
    try {
        localStorage.setItem("lang", lang);
    } catch  {
    // ignore
    }
}
function $35da740d59af89ba$var$initLanguageSwitch() {
    const saved = (()=>{
        try {
            return localStorage.getItem("lang");
        } catch  {
            return null;
        }
    })() || "pt-BR";
    $35da740d59af89ba$var$applyLanguage(saved);
    document.querySelectorAll(".lang-switch__btn").forEach((btn)=>{
        btn.addEventListener("click", ()=>{
            const lang = btn.getAttribute("data-lang") || "pt-BR";
            $35da740d59af89ba$var$applyLanguage(lang);
        });
    });
}
$35da740d59af89ba$var$initLanguageSwitch();


//# sourceMappingURL=Rezes-Portifolio.51658432.js.map
